import { z } from "zod";

const sectionDetailsSchema = z.object({
  sectionLeftTemplate: z.string(),
  sectionRightTemplate: z.string(),
  isSectionRatingEnabled: z.boolean(),
  isSectionQaEnabled: z.boolean(),
  displayPosterDay: z.boolean(),
  displaySectionGroup: z.boolean(),
});

type SectionDetailsFormData = z.infer<typeof sectionDetailsSchema>;

export { sectionDetailsSchema };
export type { SectionDetailsFormData };
